import { render, staticRenderFns } from "./EditAccountComponent.vue?vue&type=template&id=849e28c2&scoped=true&"
import script from "./EditAccountComponent.vue?vue&type=script&lang=js&"
export * from "./EditAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountComponent.vue?vue&type=style&index=0&id=849e28c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849e28c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
